import { Col, Row, Wrapper } from '@ahmdigital/ui';
import { ReactNode } from 'react';

const WrapperComponent = ({ children }: { children: ReactNode }) => (
  <Wrapper size="extraExtraLarge">
    <Row isBoxed>
      <Col df={12}>{children}</Col>
    </Row>
  </Wrapper>
);

export default WrapperComponent;
